module.exports = __webpack_public_path__ + "img/psychology.4ed0694d.jpg";